import { PageContainer } from '@/components'
import { Card, Empty } from 'antd'
import styled from 'styled-components'
import { useState } from 'react'
import { Proxy } from './proxy'
import ProxyLeft from './proxy-left'
import Scrollbars from 'react-custom-scrollbars'
import EmptyImg from '@/assets/imges/Empty/EmptyProxy.png'
const WAFProxy = () => {
  const [playItem, setPlayItem] = useState({})
  const play = values => {
    setPlayItem(values)
    // console.log('vvv', values)
  }
  return (
    <PageContainer>
      <UserContainer>
        <ProxyLeft play={play} />
        <HeaderTable>
          {playItem?.pool_id ? (
            <Proxy playItem={playItem} />
          ) : (
            <EmptyContainer>
              {/*<Empty image={EmptyImg} description={'请添加代理池'} />*/}
              <img src={EmptyImg} alt="" />
              {/*<div>请添加代理池</div>*/}
            </EmptyContainer>
          )}
        </HeaderTable>
      </UserContainer>
    </PageContainer>
  )
}

export default WAFProxy
const UserContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
`

const HeaderTable = styled.div`
  width: calc(100% - 330px);
  .header-table {
    max-width: 725px;
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 18px;
    height: 36px;
    padding: 2px;
    .tab-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 180px;
      border-radius: 8px;
      font-weight: bold;
      color: #333333;
    }
  }
  .scroll {
    padding-right: 20px !important;
  }
`

const EmptyContainer = styled(Card)`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 40px;
  img {
    display: block;
    margin-top: 50%;
    height: 30%;
  }
  div {
    text-align: center;
    //width: 192px;
    //height: 24px;
    font-size: 20px;
    font-weight: 500;
    color: #999999;
    line-height: 36px;
  }
`
